import api from "./api";

// ==================== TREINAMENTOS ====================

export const getTreinamentos = async (pagina = 1, ativo = null, busca = "") => {
  const params = new URLSearchParams({ pagina });
  if (ativo !== null) params.append("ativo", ativo);
  if (busca) params.append("busca", busca);
  const response = await api.get(`/treinamentos?${params}`);
  return response.data;
};

export const getTreinamentoById = async (id) => {
  const response = await api.get(`/treinamentos/${id}`);
  return response.data;
};

export const getTreinamentoBySlug = async (slug) => {
  const response = await api.get(`/treinamentos/slug/${slug}`);
  return response.data;
};

export const createTreinamento = async (data) => {
  const response = await api.post("/treinamentos", data);
  return response.data;
};

export const updateTreinamento = async (id, data) => {
  const response = await api.put(`/treinamentos/${id}`, data);
  return response.data;
};

export const deleteTreinamento = async (id) => {
  const response = await api.delete(`/treinamentos/${id}`);
  return response.data;
};

export const toggleTreinamentoAtivo = async (id) => {
  const response = await api.patch(`/treinamentos/${id}/toggle-ativo`);
  return response.data;
};

// ==================== MÓDULOS ====================

export const getModulos = async (idTreinamento) => {
  const response = await api.get(`/treinamentos/${idTreinamento}/modulos`);
  return response.data;
};

export const getModuloById = async (id) => {
  const response = await api.get(`/modulos/${id}`);
  return response.data;
};

export const createModulo = async (data) => {
  const response = await api.post("/modulos", data);
  return response.data;
};

export const updateModulo = async (id, data) => {
  const response = await api.put(`/modulos/${id}`, data);
  return response.data;
};

export const deleteModulo = async (id) => {
  const response = await api.delete(`/modulos/${id}`);
  return response.data;
};

export const reorderModulos = async (idTreinamento, modulos) => {
  const response = await api.patch(
    `/treinamentos/${idTreinamento}/modulos/reordenar`,
    { modulos }
  );
  return response.data;
};

// ==================== QUESTÕES (Banco) ====================

export const getQuestoes = async (pagina = 1, busca = "", id_categoria) => {
  const params = new URLSearchParams({ pagina });
  if (busca) params.append("busca", busca);
  if (id_categoria) params.append("id_categoria", id_categoria);
  const response = await api.get(`/questoes?${params}`);
  return response.data;
};

export const getQuestaoById = async (id) => {
  const response = await api.get(`/questoes/${id}`);
  return response.data;
};

export const createQuestao = async (data) => {
  const response = await api.post("/questoes", data);
  return response.data;
};

export const updateQuestao = async (id, data) => {
  const response = await api.put(`/questoes/${id}`, data);
  return response.data;
};

export const deleteQuestao = async (id) => {
  const response = await api.delete(`/questoes/${id}`);
  return response.data;
};

// ==================== ALTERNATIVAS ====================

export const addAlternativa = async (idQuestao, data) => {
  const response = await api.post(`/questoes/${idQuestao}/alternativas`, data);
  return response.data;
};

export const updateAlternativa = async (id, data) => {
  const response = await api.put(`/alternativas/${id}`, data);
  return response.data;
};

export const deleteAlternativa = async (id) => {
  const response = await api.delete(`/alternativas/${id}`);
  return response.data;
};

export const reorderAlternativas = async (idQuestao, alternativas) => {
  const response = await api.patch(
    `/questoes/${idQuestao}/alternativas/reordenar`,
    { alternativas }
  );
  return response.data;
};

// ==================== CONTEÚDO DE AULA (Blocos) ====================

export const getConteudos = async (idModulo) => {
  const response = await api.get(`/modulos/${idModulo}/conteudos`);
  return response.data;
};

export const getConteudoById = async (id) => {
  const response = await api.get(`/conteudos/${id}`);
  return response.data;
};

export const createConteudo = async (data) => {
  const response = await api.post("/conteudos", data);
  return response.data;
};

export const updateConteudo = async (id, data) => {
  const response = await api.put(`/conteudos/${id}`, data);
  return response.data;
};

export const deleteConteudo = async (id) => {
  const response = await api.delete(`/conteudos/${id}`);
  return response.data;
};

export const reorderConteudos = async (idModulo, conteudos) => {
  const response = await api.patch(`/modulos/${idModulo}/conteudos/reordenar`, {
    conteudos,
  });
  return response.data;
};

// ==================== QUESTÕES DO QUIZ ====================

export const getQuestoesQuiz = async (idModulo) => {
  const response = await api.get(`/modulos/${idModulo}/questoes`);
  return response.data;
};

export const addQuestaoQuiz = async (idModulo, data) => {
  const response = await api.post(`/modulos/${idModulo}/questoes`, data);
  return response.data;
};

export const addQuestoesQuizBulk = async (idModulo, questoes) => {
  const response = await api.post(`/modulos/${idModulo}/questoes/bulk`, {
    questoes,
  });
  return response.data;
};

export const removeQuestaoQuiz = async (idModulo, idQuestao) => {
  const response = await api.delete(
    `/modulos/${idModulo}/questoes/${idQuestao}`
  );
  return response.data;
};

export const reorderQuestoesQuiz = async (idModulo, questoes) => {
  const response = await api.patch(`/modulos/${idModulo}/questoes/reordenar`, {
    questoes,
  });
  return response.data;
};
